<template>
  <div>
    <div class="ttp">
      <div class="uploadd">
        <p class="etitle">excel上传</p>
    <el-upload
          style="margin-top: 10px"
          class="upload-demo"
          ref="upload3"
          :action="grantInfoUrl"
          multiple
          drag
          accept=".xls,.xlsx"
          :limit="1"
          :headers="myHeader"
          :before-upload="handleBeforeUpload"
          :file-list="fileList"
          :on-exceed="handleExceed"
          :on-success="uploadSuccess"
          :on-error="uploadError"
          :auto-upload="false">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          
          <div slot="tip" class="sug">1.此处excel为待发津贴查询页面导出的表格,格式请勿更改!</div>     
        </el-upload>
        <div class="btn">
         
        <el-button style="margin: 10px"  type="success" @click="submitUpload3">数据导入</el-button>
        </div>
  </div>
  </div>
  </div>
</template>

<script>
  import {baseUrl} from "../../utils/global";
  import Cookies from "js-cookie";
  let uploadedList = [];
  export default {
    name: "importByExcel",
    data() {
      return {
        grantInfoUrl: baseUrl + "/excel/deal/money",
        myHeader: {
          token: Cookies.get("token")
        },
        fileList: [],
        dialogTitle: "",
        dialogVisible: false,
        dialogContent: "",
        loading: false
      };
    },
    methods: {
      submitUpload1() {
        this.$refs.upload1.submit();
      },
      submitUpload2() {
        this.$refs.upload2.submit();
      },
      submitUpload3() {
        this.$refs.upload3.submit();
      },
      handleExceed() {
        this.$message.warning("当前限制选择 1 个文件，请删除后继续上传");
      },
      handleBeforeUpload(file) {
        this.loading = true;
        if (!file.name.endsWith(".xls") && !file.name.endsWith(".xlsx")) {
          this.$message.warning(file.name + "不是excel文件");
          this.loading = false;
          return false;
        }
        if (file.size > 50 * 1024 * 1024) {
          this.$message.warning(file.name + "文件大于50MB,无法上传");
          this.loading = false;
          return false;
        }
      },
      async uploadSuccess(response) {
        this.fileList = [];
        this.dialogTitle = "导入结果";
        this.dialogContent = response.data;
        // this.dialogVisible = true;
        this.loading = false;
        console.log("upload success");
        this.$message({
          type: "success",
          message: response.message
        });
      },
      async uploadError(response) {
        this.fileList = [];
        this.dialogTitle = "导入结果";
        this.dialogContent = "导入失败";
        //this.dialogVisible = true;
        this.loading = false;
        this.$message({
          type: "error",
          message: "系统错误",
          showClose: true,
          duration: 3000
        });
        // console.log(response);
        // this.$alert(response.data, '导入结果', {
        //   confirmButtonText: '确定',
        //   callback: action => {
        //     // this.$message({
        //     //   type: 'info',
        //     //   message: `action: ${ action }`
        //     // });
        //   }
        // });
      },
    }
  }
</script>

<style scoped>
.ttp{
  display: flex;
  border: 1px dashed lightgray;
  border-top: none;
  border-radius: 5px
}
.etitle{
  font-weight: bolder;
  font-size: 20px;
  text-align: center;
}
.sug{
  color: red;
  font-size: 20px;
}
.upload-demo{
  text-align: center;
}
.uploadd,.eg{
  width: 100%;
  padding-left: 20px
}
.btn{
  width: 50%;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/Myvue/upload_2.vue